import React from 'react';
import type { IconProps } from '../types';

// Chat/Bubbles icon - matches customer-support ChatbotButton
export const IconBubbles: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} stroke={color} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
  </svg>
);
